export { default } from 'features/cart/routes/cart-route';
